<template>
  <ExActionsPopUp
    :value="value"
    :headline="title"
    :htmlInfo="messageHtml"
    :actionLabel="buttonLabel"
    :cancelLabel="cancelLabel"
    :icon="iconName"
    :applyBorderClass="true"
    :centerHeadline="true"
    :primary="true"
    :width="maxWidth"
    actionsTopSpacing="32px"
    @input="$emit('input', $event)"
    @onAction="$emit('attach')"
  />
</template>

<script setup>
import { computed } from "vue";
import ExActionsPopUp from "@components/common/ExActionsPopUp.vue";

const props = defineProps({
  value: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: "Attach Responsibility to Role",
  },
  responsibilityName: {
    type: String,
    default: "",
  },
  roleName: {
    type: String,
    default: "",
  },
  introLine: {
    type: String,
    default: "You are about to attach responsibility",
  },
  middleLine: {
    type: String,
    default: "to role",
  },
  buttonLabel: {
    type: String,
    default: "Attach",
  },
  cancelLabel: {
    type: String,
    default: undefined,
  },
  /** Inline error shown under the message when the action fails (kept for retry). */
  error: {
    type: String,
    default: "",
  },
  iconName: {
    type: String,
    default: "org_icon_responsibility",
  },
  maxWidth: {
    type: [String, Number],
    default: 612,
  },
});

defineEmits(["input", "attach"]);

function escapeHtml(s) {
  if (s == null || s === undefined) return "";
  return String(s)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

const messageHtml = computed(() => {
  // SAFETY: every interpolated value (introLine, responsibilityName, middleLine,
  // roleName, error) is passed through escapeHtml() before being embedded, so the
  // v-html bound here never renders raw user/API-supplied markup.
  const esc = escapeHtml;
  const inner = [
    `<span style="color:#667085;">${esc(props.introLine)}</span>`,
    "<br />",
    `<span style="color:#667085;">${esc(props.responsibilityName)}</span>`,
    "<br />",
    `<span style="color:#667085;">${esc(props.middleLine)}</span>`,
    "<br />",
    `<span style="color:#667085;">${esc(props.roleName)}</span>`,
  ];
  if (props.error) {
    inner.push(
      "<br /><br />",
      `<span role="alert" style="display:block;color:#D92D20;font-weight:500;line-height:20px;">${esc(
        props.error
      )}</span>`
    );
  }
  return `<span style="display:block;text-align:center;line-height:20px;">${inner.join("")}</span>`;
});
</script>
